import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginPartnerService } from '../services/partner/login-partner/login-partner.service';

@Component({
  selector: 'app-side-nav-bar',
  templateUrl: './side-nav-bar.component.html',
  styleUrls: ['./side-nav-bar.component.css']
})
export class SideNavBarComponent implements OnInit {
  isSidebarOpen = false;
  public isPartner = false;
  public queryParamZavihek;
  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }
  closeSidebar() {
    this.isSidebarOpen = false;
  }

  constructor(public router: Router,private route: ActivatedRoute, 
    private loginPartnerService: LoginPartnerService) {
    router.events.subscribe(() => {
      this.route.queryParams.subscribe(params => {
        this.queryParamZavihek = params['zavihek'];
    });
  });
   }

  ngOnInit() {
    if(this.loginPartnerService.currentPartnerValue)
    {
      this.isPartner = true;
      
    }
  }

}
